import { AuthConfig } from 'angular-oauth2-oidc';

/**
 * Hypecast OAuth defaults layered on top of the upstream configuration.
 * Keeping this class small lets new upstream options and defaults flow through
 * without maintaining a local copy of AuthConfig.
 */
export class HypecastOAuthConfig extends AuthConfig {
  override waitForTokenInMsec: number;

  constructor(json?: Partial<AuthConfig>) {
    super(json);
    this.waitForTokenInMsec = json?.waitForTokenInMsec ?? 5000;
  }
}
